import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const photos = [
  { src: "/img/parent.jpg", alt: "An adult daughter sharing tea with her elderly father at the kitchen table", label: "An ageing parent", pos: "50% 45%" },
  { src: "/img/vet.jpg", alt: "A man holding his dog steady during a vet appointment", label: "A vet visit", pos: "55% 55%" },
  { src: "/img/teen.jpg", alt: "A teenager packing her bag for a sports session", label: "Sports kit", pos: "50% 70%" },
];

const Photo = ({ p, i }) => (
  <motion.figure
    data-testid={`hero-collage-photo-${i + 1}`}
    initial={{ clipPath: "inset(100% 0% 0% 0% round 24px)", opacity: 0.4 }}
    animate={{ clipPath: "inset(0% 0% 0% 0% round 24px)", opacity: 1 }}
    transition={{ duration: 1.2, delay: 0.55 + i * 0.18, ease: EASE }}
    className="relative overflow-hidden rounded-3xl bg-[#EFEBE3] shadow-[0_24px_50px_-28px_rgba(28,43,74,0.55)]"
  >
    <motion.img
      src={p.src}
      alt={p.alt}
      initial={{ scale: 1.15 }}
      animate={{ scale: 1 }}
      transition={{ duration: 1.8, delay: 0.55 + i * 0.18, ease: EASE }}
      className="aspect-[4/5] w-full object-cover"
      style={{ objectPosition: p.pos }}
    />
    <figcaption className="absolute bottom-2.5 left-2.5 rounded-full bg-[#FAF7F2]/90 px-2.5 py-1 text-[11px] font-semibold text-[#16203A] backdrop-blur sm:bottom-3 sm:left-3 sm:px-3 sm:text-xs">
      {p.label}
    </figcaption>
  </motion.figure>
);

export const HeroCollage = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <div ref={ref} className="relative mx-auto w-full max-w-[520px]" data-testid="hero-collage">
      <div className="grid grid-cols-2 gap-4 sm:gap-6">
        <div className="flex flex-col gap-4 sm:gap-6">
          <Photo p={photos[0]} i={0} />
          <Photo p={photos[2]} i={2} />
        </div>
        <motion.div style={{ y }} className="flex flex-col justify-center">
          <Photo p={photos[1]} i={1} />
        </motion.div>
      </div>
    </div>
  );
};
